<template>
  <div class="end-project-box">
    <div class="info">

      <el-row type="flex">
        <el-col>起始时间</el-col>
        <el-col>{{detail.trainStartTime|dateFormat('YYYY.MM.DD')}}-{{detail.trainEndTime|dateFormat('YYYY.MM.DD')}}</el-col>
        <el-col>培训地区</el-col>
        <el-col>{{detail.area}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col>收入(元)</el-col>
        <el-col>{{detail.totalCost/100}}</el-col>
        <el-col>支出(元)</el-col>
        <el-col>{{total}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col>收益率(%)</el-col>
        <el-col>{{rate}}</el-col>
        <el-col>培训规模(人)</el-col>
        <el-col>{{detail.scale}}</el-col>
      </el-row>
      <el-row type="flex">
        <el-col>邀请专家(人)</el-col>
        <el-col>{{masterNum}}</el-col>
        <el-col></el-col>
        <el-col></el-col>
      </el-row>
    </div>
    <div class="master-list">
      <div class="item" v-for="(item,index) in masters" :key="index">
        <div class="master-info">
          <img src="../../assets/img/2.png" alt="" srcset="">
          <div class="text">
            <div class="name">{{item.name}}</div>
            <div class="other-info">{{item.subject}} {{item.stage}}</div>
          </div>
        </div>
        <div class="comments-area">
          <div class="line">
            <el-form-item label="费用：" prop="fee" label-width='auto'>
              <el-input v-model.number="item.fee" :disabled='disabled'></el-input>
            </el-form-item>
            <el-form-item label="备注：" class="train-hour" prop="remark" label-width='auto'>
              <el-input v-model="item.remark" :disabled='disabled'></el-input>
            </el-form-item>

          </div>
          <el-input type="textarea" placeholder="请输入评价信息" v-model="item.comment" :disabled='disabled'>
          </el-input>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as projectApi from '../../api/projectAPI'
import * as resourceApi from '../../api/resourceAPI'
import commonData from '../../common/commonData'

export default {
  components: {

  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comments: "",
      masters: [],
      memberList: [],
      projectId: '',
      stageMap: {},
      subjectMap: {},
      importShow: false,
      feeList: [],
      masterNum:0,
      studentNum:0
    };
  },
  computed: {
    total() {
      return this.feeList.reduce((pre, curr) => pre + (curr.fee || 0), 0) / 100
    },
    rate() {
      return ((this.detail.totalCost / 100 - this.total) / (this.detail.totalCost / 100) * 100).toFixed(2) + "%"
    },
  },
  watch: {

  },
  created() {

    this.stageMap = commonData.stage
    this.subjectMap = commonData.subject

  },
  async mounted() {
    this.projectId = this.$route.params.id
    await this.qryFeeList()
    await this.qryMemberList()
    await this.qryMasterInfo()
  },
  methods: {
   
    async qryFeeList() {
      let res = await projectApi.qryProjectFee(this.projectId)
      if (res.flag) {
        this.feeList = res.data
      }
    },
    async qryMemberList() {
      this.projectId = this.$route.params.id

      let res = await projectApi.qryProjectMember({ projectId: this.projectId })
      if (res.flag) {
        this.memberList = res.data.filter(m => m.memberType ==1)
        this.masterNum = this.memberList.length
        this.studentNum = res.data.filter(m => m.memberType ==0).length
      }
    },
    async qryMasterInfo() {
      let ids = this.memberList.map(m => m.memberId)
      if (!ids.length) {
        return
      }
      let param = {}
      param.where = [{ filed: 'id', type: 'in', value: ids.join(',') }]
      param.name = 'tb_master'
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.masters = res.data.list.map(m => {
          let find = this.memberList.find(item => item.memberId == m.id)
          m.comment = find.comment
          m.fee = find.fee
          m.remark = find.remark
          return m
        })
      }
    },

  },
};
</script>

<style  lang="less">
.end-project-box {
  .info {
    padding: 20px 30px;
    .el-row {
      color: #3c4353;
      font-size: 12px;

      border-right: 1px solid #dedede;
      .el-col {
        border-top: 1px solid #dedede;
        border-left: 1px solid #dedede;
        padding: 10px 20px;
      }
      .el-col:nth-child(odd) {
        background: #f8f9fb;
        text-align: right;
        max-width: 150px;
      }
    }
    .el-row:last-child {
      border-bottom: 1px solid #dedede;
    }
  }
  .master-list {
    padding: 0 30px;
    margin-bottom: 40px;
    .item {
      display: flex;
      border-radius: 5px;
      border: 1px solid #e2e2e2;
      margin-bottom: 10px;
      .master-info {
        padding: 10px;
        display: flex;
        align-items: center;
        border-right: 1px solid #e2e2e2;
        width: 160px;
        img {
          width: 60px;
          border-radius: 30px;
        }
        .text {
          text-align: center;
          margin-left: 10px;
          .name {
            color: #3c4353;
            font-size: 14px;
            margin-bottom: 10px;
            white-space: nowrap;
          }
          .other-info {
            font-size: 12px;
            color: #ccc;
            white-space: nowrap;
          }
        }
      }
      .comments-area {
        width: 100%;
        .line {
          display: flex;
          .el-form-item {
            flex: 1;
            display: flex;
            border-bottom: 1px solid #e2e2e2;
            padding-left: 10px;
            margin-bottom: 0;
            label {
              padding-right: 0;
            }
            input {
              border: none;
              background: #fff;
            }
          }
          .train-hour {
            border-left: 1px solid #e2e2e2;
          }
        }
        textarea {
          height: 80px;
          border: none;
        }
      }
    }
  }
}
</style>
